// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bb3365b8","77":"362d9349","115":"ba25f6ef","222":"04f992de","280":"f6ea1214","354":"47c4cd92","444":"31bd161e","523":"7e7c7a01","526":"dae95be6","567":"b317f83b","850":"b4e70e36","860":"51f2eb59","928":"63b4930f"}[chunkId] + ".chunk.js";
};